import { symbol } from "./symbol.js";
<ebay-icon ...input _name="spinner-30" _size="30" _type="icon" _themes=symbol/>